import React, { useContext } from "react";
import PropTypes from "prop-types";

import { sortedDataShape } from "../Types";

import MapContext from "../context/MapContext";
import Marker from "./Marker";

// Markers are the pins on the map
// This component handles the conditional rendering of all the markers on the map
// We only see markers based on the category that is selected from the menu

const Markers = () => {
	const {
		data: { locations, selectedCategory },
	} = useContext(MapContext);

	if (!locations || !selectedCategory) return null;

	return locations[selectedCategory].map((location) => {
		return location.pins.map((pin, pinIndex) => {
			return (
				<Marker
					key={`${location.name}-${pinIndex}`}
					location={location}
					index={pinIndex}
					position={pin}
				></Marker>
			);
		});
	});
};

Markers.propTypes = {
	data: sortedDataShape,
	selectedCategory: PropTypes.string,
	highlightedMenuItem: PropTypes.string,
};

export default Markers;
